<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="ch00_fm09_half1"></a><a id="page_xiii"></a><strong>Keeping Your Child Healthy in a Germ-Filled World</strong><a id="page_xiv"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm09_half1.vue?5a064781